 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"8d0c071f2210536a544c9bf56416ef9a64e18163","2":"de5b7c63ba68896034865ce29add99db62e60a18","3":"a9d3805909a28c90c609ff7f50c61150882a518e","4":"44cb58f2e6fcd2eb1a10482fdb18678762f45c15","5":"2e8e49993f43d1471daa31bd457ab8637269faad","6":"a4c92b5b","7":"f6d80b4e5bec7b791e989e1ab0e7288987f02f86","8":"7b209c3345d92abea6b160ffa2ab4dd01c3e6770","9":"a656cea4aeabd6d651c8f2159ba06833a393a493","10":"520d75254f688c45e52c1ae1f8615bb0a18b23ce","11":"775cbc166ccb32e641d59a874a2b48a4fb904795","12":"2293bb39a1229e2750f5acea87b7c8dedaf35036","13":"323e1820c5c978307575aa5c47801f0a64af9d3a","14":"6264b85f94d8b35da7cf020631ed05257c2868ad","15":"92581cf2c0a22e44ef923c0536027b96abf22498","16":"e528f9020b5aca1fa3959f28315315893f256883","19":"component---src-pages-404-jsx","20":"component---src-pages-driverevenue-jsx","21":"component---src-pages-driverevenue-workshop-jsx","22":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-jsx","23":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-uk-jsx","24":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-jsx","25":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-uk-jsx","26":"component---src-pages-index-jsx","27":"component---src-pages-index-uk-jsx","28":"component---src-pages-open-roles-jsx","29":"component---src-pages-open-roles-uk-jsx","30":"component---src-pages-resources-jsx","31":"component---src-pages-resources-old-jsx","32":"component---src-pages-resources-uk-jsx","33":"component---src-pages-retention-vs-wunderkind-jsx","34":"component---src-pages-security-profile-jsx","35":"component---src-pages-self-service-platform-tos-jsx","36":"component---src-pages-wunderkind-eu-visitor-jsx","37":"component---src-templates-about-us-jsx","38":"component---src-templates-about-us-uk-jsx","39":"component---src-templates-blog-jsx","40":"component---src-templates-case-study-jsx","41":"component---src-templates-case-study-uk-jsx","42":"component---src-templates-client-referral-jsx","43":"component---src-templates-client-referral-thank-you-jsx","44":"component---src-templates-client-referral-thank-you-uk-jsx","45":"component---src-templates-client-referral-uk-jsx","46":"component---src-templates-competitor-jsx","47":"component---src-templates-competitor-uk-jsx","48":"component---src-templates-consumer-insights-hub-jsx","49":"component---src-templates-culture-jsx","50":"component---src-templates-culture-uk-jsx","51":"component---src-templates-industry-jsx","52":"component---src-templates-inner-page-jsx","53":"component---src-templates-inner-page-uk-jsx","54":"component---src-templates-lookbook-js","55":"component---src-templates-lookbook-post-js","56":"component---src-templates-lookbook-uk-js","57":"component---src-templates-our-vision-jsx","58":"component---src-templates-performance-marketing-marketo-jsx","59":"component---src-templates-plain-content-jsx","60":"component---src-templates-plain-content-uk-jsx","61":"component---src-templates-podcast-jsx","62":"component---src-templates-podcast-uk-jsx","63":"component---src-templates-resource-get-started-jsx","64":"component---src-templates-resource-jsx","65":"component---src-templates-resource-uk-jsx","66":"component---src-templates-resources-jsx","67":"component---src-templates-resources-uk-jsx","68":"component---src-templates-solutions-jsx","69":"component---src-templates-solutions-uk-jsx","70":"component---src-templates-unsubscribe-confirmation-jsx","71":"component---src-templates-unsubscribe-confirmation-uk-jsx","72":"component---src-templates-unsubscribe-jsx","73":"component---src-templates-unsubscribe-uk-jsx","74":"component---src-templates-video-jsx","75":"component---src-templates-wkd-bluecore-jsx"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"d4cbd28719f74a77b021","2":"9886faa02bd7503a1a2a","3":"f9b6843e32c7d6156899","4":"39e68d8066e2fb544ee3","5":"89f4be0abb8832f4328b","6":"b42699d7e0c9f0f5f343","7":"a1df884a23f946a48bca","8":"348b6334ef09408602c8","9":"4715ec358b135fb86a3a","10":"781fad060579d0818d82","11":"e9799fc22d6344aaf1c2","12":"428f79bcb763f96ab02b","13":"b5831a8a74f75e951d33","14":"2c264008cccef4261bee","15":"ae3ca8b616c781c7a88a","16":"eb09532cdc8116c0bb2e","19":"8ae56e21e86313fba0c0","20":"11205ca85c617b7a7fd8","21":"2cc141c8e5823757b95d","22":"7572e6bf42f83245d001","23":"fe5bb93070c276d92073","24":"841932ca37f155735ef8","25":"342ae1acd202821fb3d7","26":"adb39df5d70b381d48e8","27":"8b2b747a76f57581b373","28":"050b721661aa80d5a8ae","29":"e2f3f14c72e1e6acc1ca","30":"6d6a282f8177a8b3542f","31":"537f3b2571717dda9468","32":"f0fa66cd66297b963f66","33":"03209d2c602f05f16b4b","34":"2ffb653d8245f8f31662","35":"29b30ff2cf0b06a9e9ea","36":"81c643a31be607fe0286","37":"031b9099bdaeb1b285be","38":"2bb0b890490aeb9af9cb","39":"1a847df9359622e30130","40":"72b4a5b69e54003c3650","41":"b994cd575ba6e663766b","42":"2cdb8650af423780067c","43":"0160a213b50743a75049","44":"006bb51c0be8dbad1f38","45":"21efb7293e723d011e22","46":"b4dd92634db15882816c","47":"35ef4b96e376cf4e14c5","48":"874937740d5fd6db9026","49":"20314460b5b8cf721433","50":"510c681c3e6eb006147b","51":"9886bf2f532c6936a4dd","52":"e9ccbcc03edd8aad8fde","53":"1a6b744ae659864db184","54":"8b20175a26ae413d04a2","55":"75f47fa948b85ae13551","56":"edd656bc87c503abe851","57":"9bf6cb343942b7695224","58":"93161dc4b75192b46c7a","59":"2b7217db1d5f222b49ef","60":"f22f09078e484d79425d","61":"49eadb2d6015f987be67","62":"1eb30dafadd47607091c","63":"96a07077c6866632dea2","64":"21074cdd3ea465149173","65":"b7086e4ba8fa84842441","66":"6519ba9e3197f6be8771","67":"d992821a1602a4b14684","68":"3f124ba30ceead94e731","69":"d3bb44b884a47cac3a57","70":"a98dd6aeacf664c8ac31","71":"1e79bdcf436c2bbbb43f","72":"331bd1580ce2729ba683","73":"610747c550d173901599","74":"2cd5b7acb64c1ebc5804","75":"1b3e282bff02fb5dad79"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"8d0c071f2210536a544c9bf56416ef9a64e18163","2":"de5b7c63ba68896034865ce29add99db62e60a18","3":"a9d3805909a28c90c609ff7f50c61150882a518e","4":"44cb58f2e6fcd2eb1a10482fdb18678762f45c15","5":"2e8e49993f43d1471daa31bd457ab8637269faad","6":"a4c92b5b","7":"f6d80b4e5bec7b791e989e1ab0e7288987f02f86","8":"7b209c3345d92abea6b160ffa2ab4dd01c3e6770","9":"a656cea4aeabd6d651c8f2159ba06833a393a493","10":"520d75254f688c45e52c1ae1f8615bb0a18b23ce","11":"775cbc166ccb32e641d59a874a2b48a4fb904795","12":"2293bb39a1229e2750f5acea87b7c8dedaf35036","13":"323e1820c5c978307575aa5c47801f0a64af9d3a","14":"6264b85f94d8b35da7cf020631ed05257c2868ad","15":"92581cf2c0a22e44ef923c0536027b96abf22498","16":"e528f9020b5aca1fa3959f28315315893f256883","19":"component---src-pages-404-jsx","20":"component---src-pages-driverevenue-jsx","21":"component---src-pages-driverevenue-workshop-jsx","22":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-jsx","23":"component---src-pages-how-it-works-advertising-solutions-for-advertisers-and-publishers-uk-jsx","24":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-jsx","25":"component---src-pages-how-it-works-performance-marketing-solutions-for-ecommerce-uk-jsx","26":"component---src-pages-index-jsx","27":"component---src-pages-index-uk-jsx","28":"component---src-pages-open-roles-jsx","29":"component---src-pages-open-roles-uk-jsx","30":"component---src-pages-resources-jsx","31":"component---src-pages-resources-old-jsx","32":"component---src-pages-resources-uk-jsx","33":"component---src-pages-retention-vs-wunderkind-jsx","34":"component---src-pages-security-profile-jsx","35":"component---src-pages-self-service-platform-tos-jsx","36":"component---src-pages-wunderkind-eu-visitor-jsx","37":"component---src-templates-about-us-jsx","38":"component---src-templates-about-us-uk-jsx","39":"component---src-templates-blog-jsx","40":"component---src-templates-case-study-jsx","41":"component---src-templates-case-study-uk-jsx","42":"component---src-templates-client-referral-jsx","43":"component---src-templates-client-referral-thank-you-jsx","44":"component---src-templates-client-referral-thank-you-uk-jsx","45":"component---src-templates-client-referral-uk-jsx","46":"component---src-templates-competitor-jsx","47":"component---src-templates-competitor-uk-jsx","48":"component---src-templates-consumer-insights-hub-jsx","49":"component---src-templates-culture-jsx","50":"component---src-templates-culture-uk-jsx","51":"component---src-templates-industry-jsx","52":"component---src-templates-inner-page-jsx","53":"component---src-templates-inner-page-uk-jsx","54":"component---src-templates-lookbook-js","55":"component---src-templates-lookbook-post-js","56":"component---src-templates-lookbook-uk-js","57":"component---src-templates-our-vision-jsx","58":"component---src-templates-performance-marketing-marketo-jsx","59":"component---src-templates-plain-content-jsx","60":"component---src-templates-plain-content-uk-jsx","61":"component---src-templates-podcast-jsx","62":"component---src-templates-podcast-uk-jsx","63":"component---src-templates-resource-get-started-jsx","64":"component---src-templates-resource-jsx","65":"component---src-templates-resource-uk-jsx","66":"component---src-templates-resources-jsx","67":"component---src-templates-resources-uk-jsx","68":"component---src-templates-solutions-jsx","69":"component---src-templates-solutions-uk-jsx","70":"component---src-templates-unsubscribe-confirmation-jsx","71":"component---src-templates-unsubscribe-confirmation-uk-jsx","72":"component---src-templates-unsubscribe-jsx","73":"component---src-templates-unsubscribe-uk-jsx","74":"component---src-templates-video-jsx","75":"component---src-templates-wkd-bluecore-jsx"}[chunkId]||chunkId) + "." + {"0":"40d21b5804adee137290","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
